var map = {
	"./": 481,
	"./OldUi": 2687,
	"./OldUi.js": 2687,
	"./SpireonNew": 2688,
	"./SpireonNew.js": 2688,
	"./SpireonOld": 2689,
	"./SpireonOld.js": 2689,
	"./index": 481,
	"./index.js": 481,
	"./style": 370,
	"./style.js": 370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4192;